import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router';

import ErrorBoundary from 'app/components/common/ErrorBoundary';

const ExtendedRoute = ({ component: Component, platform, ...rest }) => {
  const render = (props) => (
    <ErrorBoundary platform={platform}>
      <Component {...props} />
    </ErrorBoundary>
  );

  return <Route {...rest} render={render} />;
};

ExtendedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  platform: PropTypes.string,
};

ExtendedRoute.defaultProps = {
  platform: null,
};

const mapStateToProps = (state) => ({
  platform: state.common.platform,
});
const connector = connect(mapStateToProps);

export default connector(ExtendedRoute);



// WEBPACK FOOTER //
// ./src/app/components/routes/Route/index.jsx